import BUApi from './_buApi';
import httpClient from '@/apis/base/httpclient';

class BUPlanWDAdjustmentAPI extends BUApi {
  constructor() {
    super();
  }
  controllerName = 'BUPlanWDAdjustments';

  /**
   * Hàm get dữ liệu điều chỉnh
   * @param {*} payload
   * @returns
   * NNLINH 19.07.2022
   */
  async getDataBUPlanWDAdjustment(payload) {
    let apiUrl = this.getAPIUrl();

    let request = {
      url: apiUrl + '/getData',
      data: payload
    };

    return await httpClient.postAsync(request);
  }
  /**
   * Hàm get dữ liệu điều chỉnh thực chi
   * @param {*} payload
   * @returns
   * TPNAM 08.05.2023
   */
  async getDataBuExpenseWdAdjustment(payload) {
    let apiUrl = this.getAPIUrl();

    let request = { url: apiUrl + '/DataBuExpenseWdAdjustment', data: payload };

    return await httpClient.postAsync(request);
  }
}

export default new BUPlanWDAdjustmentAPI();
